import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'orcamento-tipo-verba');

const orcamentoActions = {
  buscarAtivos: { method: 'GET', url: `${basePath}/ativos` },
  buscarTipoVerba: { method: 'GET', url: `${basePath}/{id}` },
  ultimoAno: { method: 'GET', url: `${basePath}/{id}/ultimo-ano` },
  buscarPorIdVerbaInvestimento: { method: 'GET', url: `${basePath}/investimento/{idOrcamentoVerbaInvestimento}` },
};

export default resource => resource(`${basePath}`, {}, orcamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/orcamento-tipo-verba.js